import { ref } from "vue";

export default (): (ref<string> | ref<boolean>)[] => {
  const UA = navigator.userAgent;

  const IOS = UA.match(/iPhone|iPad|iPod|ipad|iphone|ipod/);
  const ANDROID = UA.match(/Android|android/);

  // eslint-disable-next-line no-nested-ternary
  const Platform = ref(IOS ? "ios" : ANDROID ? "android" : "unknown");

  const standalone =
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const Installed = ref(!!(standalone || (IOS && !UA.match(/Safari/))));

  if (!Installed.value) {
    if (UA.match(/Firefox/) && navigator.getInstalledRelatedApps) {
      navigator.getInstalledRelatedApps().then((relatedApps) => {
        // Check if your PWA is among the installed related apps
        const isInstalled = relatedApps.some((app) => app.platform === "web");
        if (isInstalled) {
          Installed.value = true;
        }
      });
    }

    if (UA.match(/Samsung/)) {
      const beforeinstallpromptTriggered = ref(false);      
      Installed.value = true;
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        beforeinstallpromptTriggered.value = true;
      });
      setTimeout(() => {
        Installed.value = !beforeinstallpromptTriggered.value;
      }, 1000);
    }
  }

  return [Platform, Installed];
};
